import React from 'react'
import { useTranslation } from 'react-i18next'
import { usePageContext } from 'pageContext'
import { Card } from 'packages/eid-ui'
import { Box } from '@mui/material'
import { EidAutocomplete } from 'packages/eid-controls'
import { Icon } from 'packages/eid-icons'
import { isNilOrEmpty } from 'packages/core'

const OptionComponent = EidAutocomplete.getOptionComponent({
    type: 'label',
    labelProp: 'friendlyName',
})

const getOptionLabel = (option) => option.friendlyName

const queryParams = {
    take: 20,
}

const ItemTypeActionFilter = () => {
    const { t } = useTranslation()
    const [state, dispatch] = usePageContext()

    const filter = (
        <Box padding="18px">
            <EidAutocomplete.New
                placeholder={t('SelectOrSearch')}
                url={'/api/Lookup/businessRequestItemTypeActions'}
                queryParams={queryParams}
                getOptionLabel={getOptionLabel}
                dedupingInterval={60000}
                value={state.itemTypeAction ? state.itemTypeAction : null}
                optionComponent={OptionComponent}
                clearIcon={
                    !isNilOrEmpty(state.itemTypeAction) && (
                        <Icon
                            name="Close"
                            color="#959598"
                            onClick={() =>
                                dispatch({
                                    type: 'SET_PROP',
                                    payload: {
                                        key: 'itemTypeAction',
                                        value: null,
                                    },
                                })
                            }
                        />
                    )
                }
                onChange={(_, value) => {
                    dispatch({
                        type: 'SET_PROP',
                        payload: {
                            key: 'itemTypeAction',
                            value: value,
                        },
                    })
                }}
            />
        </Box>
    )

    return (
        <Card
            cardTitle={t('ItemTypeAction')}
            color="#fff"
            collapsible
            expanded={Boolean(state.itemTypeAction)}
        >
            {filter}
        </Card>
    )
}

export default ItemTypeActionFilter
